import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ButtonBase } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { ALL, ACTIVE, INACTIVE } from "../../consts/driverDetails";
import { palette } from "../../theme/palette";

import { shiftManagerViewSelector } from "../../reducers/shiftManagerManagement/selectors";
import { setShiftManagerView } from "../../reducers/shiftManagerManagement/thunkActions";

import {
  AllShiftManagers,
  ActiveShiftManagers,
  InactiveShiftManagers,
} from "../Icons";
import { View } from "../View";

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "space-around",
    paddingTop: "5px",
    paddingBottom: "5px",
    color: "white",
    "& svg": {
      height: "32px",
      width: "32px",
      cursor: "pointer",
    },
  },
  padding: {
    height: "28px !important",
    width: "28px !important",
    paddingTop: "2px",
    paddingBottom: "2px",
  },
});

export const ShiftManagerViews = memo(() => {
  const view = useSelector(shiftManagerViewSelector);
  const dispatch = useDispatch();
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <ButtonBase
        onClick={() => {
          dispatch(setShiftManagerView(ACTIVE));
        }}
        disableRipple={true}
      >
        <ActiveShiftManagers
          fill={
            view === ACTIVE ? palette.orange : palette.typography.white.high
          }
        />
      </ButtonBase>
      <ButtonBase
        onClick={() => {
          dispatch(setShiftManagerView(INACTIVE));
        }}
        disableRipple={true}
      >
        <InactiveShiftManagers
          fill={
            view === INACTIVE ? palette.orange : palette.typography.white.high
          }
        />
      </ButtonBase>
      <ButtonBase
        onClick={() => {
          dispatch(setShiftManagerView(ALL));
        }}
        disableRipple={true}
      >
        <AllShiftManagers
          className={styles.padding}
          fill={view === ALL ? palette.orange : palette.typography.white.high}
        />
      </ButtonBase>
    </View>
  );
});

export default ShiftManagerViews;
